import { useQuery } from '@tanstack/react-query';
import { fetchCensus, type CensusResponse } from './client.js';
import type { ActiveCatchment } from '../workspace/catchment-link.js';

// A compact signature so the query key changes when the catchment changes, but
// we don't stuff a 1000+-point polygon into the key.
function sig(c: ActiveCatchment): string {
  // Polygon: coordinates[0] is the outer ring. MultiPolygon: coordinates is a
  // list of polygons, each polygon[0] a ring — key off the first ring + count.
  const firstRing: number[][] =
    c.polygon.type === 'MultiPolygon'
      ? (c.polygon.coordinates[0]?.[0] ?? [])
      : (c.polygon.coordinates[0] ?? []);
  const nParts = c.polygon.type === 'MultiPolygon' ? c.polygon.coordinates.length : 1;
  const n = firstRing.length;
  const mid = firstRing[Math.floor(n / 2)] ?? [0, 0];
  return `${c.market}|${c.region ?? ''}|${nParts}|${n}|${firstRing[0]?.join(',')}|${mid.join(',')}`;
}

export function useCensus(active: ActiveCatchment | null) {
  return useQuery<CensusResponse, Error>({
    queryKey: ['census', active ? sig(active) : null] as const,
    queryFn: () =>
      fetchCensus({
        polygon: active!.polygon,
        market: active!.market,
        country: active!.market,
        region: active!.region,
      }),
    enabled: !!active,
    staleTime: 5 * 60_000,
  });
}
